<template>
  <div>
    <fetching-data-spinner
      :error="fetchError"
      :loading="fetch"
      :loading-title="$t('general.load-settings')"
      enable-retry
      @retry="fetchBotReply"
    />
    <b-card v-if="!fetch">
      <b-form-checkbox
        v-model="enable"
        switch
      >
        {{ $t(`instagram.enable-${keyword}`) }}
      </b-form-checkbox>
      <b-card-sub-title />
    </b-card>
  </div>
</template>

<script>
import FetchingDataSpinner from '@/@bya3/components/utils/FetchingDataSpinner'
import { BCard, BCardSubTitle, BFormCheckbox } from 'bootstrap-vue'
import ChatBotApi from '@/api/bot'
import { mapGetters } from 'vuex'
import ReplyMixin from '@/mixins/reply-mixin'

export default {
  name: 'EnableDisableReply',
  components: {
    BCard, BCardSubTitle, BFormCheckbox, FetchingDataSpinner,

  },
  mixins: [ReplyMixin],
  props: {
    keyword: {
      type: String,
      default: 'story-mention',
    },

  },
  data() {
    return {
      fetch: true,
      enable: false,
      fetchError: null,
    }
  },
  computed: {
    ...mapGetters({
      currentAccount: 'instagram/currentAccount',
      form: 'bot/form',
    }),
  },
  watch: {
    enable(val) {
      this.$emit('input', val)
      if (!val && this.form?.id) {
        this.disableBot()
      }
    },
  },
  mounted() {
    this.fetchBotReply()
  },
  methods: {
    async fetchBotReply() {
      // For direct Instagram accounts, page is null, so use account_id or 0 as pageId
      const pageId = this.currentAccount.page?.id ?? this.currentAccount.id ?? 0
      await ChatBotApi.fetchByKeyword(pageId, { keyword: this.keyword, media_type: 'ig', is_direct: this.currentAccount.is_direct }).then(async res => {
        this.enable = !!res?.reply?.id
        if (res.reply) {
          const form = {
            message_type: res.reply.message[0].template_type,
            id: res.reply?.id ?? null,
            is_direct: this.currentAccount.is_direct,
          }
          this.$store.commit('bot/SET_FORM', form)

          this.setMessage(res.reply.message[0].reply, form.message_type, 'bot/')
        }
      }).catch(e => {
        this.fetchError = e
      })
        .finally(() => {
          this.fetch = false
          this.$emit('fetched', true)
        })
    },
    disableBot() {
      this.$okConfirm(this.$t('instagram.disable-story-mention-msg'), {
        confirmButtonText: this.$t('forms.submit'),
        showCancel: true,
        preConfirm: () => {
          // For direct Instagram accounts, page is null, so use account_id or 0 as pageId
          const pageId = this.currentAccount.page?.id ?? this.currentAccount.id ?? 0
          return ChatBotApi.deleteBot(pageId, this.form.id, this.currentAccount.is_direct)
            .then(response => {
              if (response.error === 0) {
                this.$store.commit('bot/SET_DEFAULT_FORM')
                this.$notifySuccess(response.message)
              }
            })
            .catch(e => this.$notifyError(e))
        },
      })
    },
  },
}
</script>
